export const ACTIONS = {
    SET_SOURCE_SEGMENT_FOR_SCENE: 'SET_SOURCE_SEGMENT_FOR_SCENE',
    SET_DATASET_METADATA: 'SET_DATASET_METADATA',
    SET_RECOMMENDED_VIDEO_REQUEST_RESPONSE: 'SET_RECOMMENDED_VIDEO_REQUEST_RESPONSE',
};

export type DatasetMetadata = {
    scenes: Record<string, Record<string, string>>;
    video: Record<string, string>;
};
